import GlobalStore from '../../../store';

export default {
  data() {
    return {
      globalStore: GlobalStore,
      acServiceMappings: {},
      acServiceFormData: {}
    };
  },
  methods: {
    loadMappedAutoCompletes(mappings, formData) {
      const storeNames = [];
      Object.entries(mappings).forEach(async ([, value]) => {
        // If there are multiple controls on the page that use the same data store, we want to consolidate that into one
        if (!storeNames.some(storeName => storeName === value.store)) {
          storeNames.push(value.store);
          await this.loadActiveDataSource(this.buildDataSourcePayload(value));
        }
      });
      this.acServiceFormData = formData;
      this.acServiceMappings = mappings;
    },
    buildDataSourcePayload(mapping) {
      let payload = { storeName: mapping.store };
      if (mapping !== undefined) {
        const { searchKey } = mapping;
        const dependencyName = mapping.dependsOn;
        const dependencyFormPropertyID = this.acServiceMappings[dependencyName]?.formProps?.idField;
        const searchValue = this.acServiceFormData[dependencyFormPropertyID];
        if ((dependencyName === null || dependencyName === undefined || searchValue > 0) && !mapping.isServerSide) {
          payload = { storeName: mapping.store, searchKey, searchValue };
        } else {
          payload = null;
        }
      }
      return payload;
    },
    async loadActiveDataSource(payload) {
      if (payload !== null && this.globalStore.state.AutoCompletes[payload.storeName].dataSource.length === 0) {
        await this.globalStore.dispatch('loadDataSource', payload);
      }
    }
  }
};
